export enum TStatableType {
  Company = 'Company',
  StudentSociety = 'StudentSociety',
}

export enum StatKindEnum {
  NET_ZERO = 'net_zero',
}

type TStat<StatableType, StatType> = {
  id: string;
  type: StatType;
  title: string;
  value: string;
  position: number;
  emoji: string | null;
  kind: StatKindEnum | null;
  statable_id: string;
  statable_type: StatableType;
};

type TStatResponse<StatableType, StatResponseType, StatType> = {
  id: string;
  type: StatResponseType;
  attributes: TStat<StatableType, StatType>;
};

export type TStatsResponse<StatableType, StatResponseType, StatType> = {
  data: Array<TStatResponse<StatableType, StatResponseType, StatType>>;
};

export interface TStatRequest {
  id?: string;
  title: string;
  value?: string;
  _destroy?: boolean;
}
